import { createFileRoute } from '@tanstack/react-router';

import Step2Billing from 'component/view/Onboarding/Step2Billing';

import { blockRegistrationInWpSiteControl, requireNoPlan } from './-guards';

export const Route = createFileRoute('/n/_auth/register/plan')({
  beforeLoad: async ctx => {
    // Block registration routes in WP Site Control mode
    blockRegistrationInWpSiteControl();
    await requireNoPlan(ctx);
  },
  component: Step2Billing,
});
